/**
 * Strips every non-digit character. Empty input -> ''.
 * Example: '(770) 866-6105' -> '7708666105'.
 */
export const digitsOnly = (value) =>
    value ? `${value}`.replace(/\D/g, '') : '';

/**
 * Formats a US phone number as '(AAA) BBB-CCCC'. A US number is exactly 10
 * digits, or 11 digits that start with 1. Any other value is returned as
 * stored. Empty input -> ''.
 * Example: '+17708666105' -> '(770) 866-6105'.
 */
export const formatPhoneNumber = (value) => {
    if (!value) return '';

    const digits = digitsOnly(value);
    const isUsWithCountryCode = digits.length === 11 && digits.startsWith('1');
    if (digits.length !== 10 && !isUsWithCountryCode) return value;

    const local = digits.slice(-10);
    return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
};
